// extracted by mini-css-extract-plugin
export var active = "_1l-9";
export var backButton = "_1l-8";
export var clone = "_1l-e";
export var collapseBar = "_1l-k";
export var collapseMode = "_1l-m";
export var collapsed = "_1l-o";
export var dimmed = "_1l-i";
export var dragHandle = "_1l-c";
export var dropdownIcon = "_1l-g";
export var expanding = "_1l-n";
export var hidden = "_1l-x";
export var iconContainer = "_1l-q";
export var iconSwapper = "_1l-w";
export var navItem = "_1l-6";
export var navItemIcon = "_1l-f";
export var navProfile = "_1l-7";
export var notificationCountBadge = "_1l-j";
export var notificationDot = "_1l-r";
export var optionsContainer = "_1l-h";
export var primaryNav = "_1l-0";
export var primaryNavDivider = "_1l-v";
export var primaryNavResizeHandle = "_1l-2";
export var primaryNavResizing = "_1l-1";
export var primaryNavTabSection = "_1l-u";
export var primaryTab = "_1l-p";
export var primaryTabIconBox = "_1l-s";
export var secondaryNav = "_1l-3";
export var selected = "_1l-t";
export var settingsNav = "_1l-4";
export var settingsNavItems = "_1l-5";
export var show = "_1l-d";
export var sideNav = "_1l-l";
export var teamItem = "_1l-a";
export var userProfileItem = "_1l-b";